function alif(t) {
  return [[0, t * 125], t + .003];
}

module.exports = [[alif, [-40, 0]]];



/*****************
 ** WEBPACK FOOTER
 ** ../JSCalligrapher/alphabets/abjad/alif_i.js
 ** module id = 7
 ** module chunks = 0
 **/